import React, { useState, useEffect } from 'react'

// Material UI
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'

// Icons
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const MultipleChoices = ({ options, index, addChoice, clientData }) => {

    const { language } = clientData

    const [selectedChoices, setSelectedChoices] = useState([])

    const styles = { alignItems: "baseline" }

    // Erase the first choice when choice quantity limit is reached
    // Example 4 choices, first one in array is erased
    // Remaining 3 choices
    const choiceQuantityLimit = (selectedChoice) => {

        let choiceQty
        let choice = { ...selectedChoice }

        if (options.Choice_Qty === 0)
            choiceQty = 99
        else
            choiceQty = options.Choice_Qty

        if (choiceQty <= selectedChoices.length)
            selectedChoices.shift()

        return [...selectedChoices, choice]

    }

    const setCheckedItems = (choice) => {

        choice.Quantity = 1

        setSelectedChoices(
            (selectedChoices.some(x => x.UID === choice.UID)
                ? selectedChoices.filter(x => x.UID !== choice.UID)
                : choiceQuantityLimit(choice)
            )
        )
    }

    useEffect(() => {

        let choices
        let totalAmount = selectedChoices.reduce((sum, option) => sum + option.Price, 0)

        choices = {
            UID: options.UID,
            name: options.Name,
            expected: options.Choice_Qty,
            selected: selectedChoices.length,
            price: totalAmount,
            choices: selectedChoices
        }

        addChoice(index, choices)
        // eslint-disable-next-line
    }, [selectedChoices])

    if (options.length === 0) {
        return <>Loading....</>
    }

    const styleMaxmiumRequired = {
        color: "#f44336",
        marginRight: 14,
        marginTop: 3,
        fontSize: "0.85rem",
        lineHeight: 1.66,
        letterSpacing: "0.03333em",
    }

    return (
        <>
            <List>
                <h3>{options.Name} <span style={styleMaxmiumRequired}>( {Language.ItemRequiredMaximum[language]} {options.Choice_Qty} )</span></h3>
                {options.Choices.map((choice) =>
                    <div key={choice.UID}>
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                {choice.Name}
                            </Grid>
                            <Grid item>
                                <>
                                    {(choice.Price === 0) ? "" : choice.Price.toFixed(2) + "$"}
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={selectedChoices.some(x => x.UID === choice.UID)}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => setCheckedItems(choice)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                    </div>
                )}
            </List>
        </>
    )
}

const mapStateToProps = state => {
    return {
        clientData: state.clientData
    }
}

export default connect(mapStateToProps)(MultipleChoices)